import React from "react"
import {Drawer, Row, Col} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import Menu from '../Menu'

function MobileMenu(props) {

  const onClose = () => {
    props.setVisible(false)
  }

  return (
      <Drawer
          placement="left"
          closable={false}
          onClose= {onClose}
          visible={props.visible}
          width={'80%'}
          bodyStyle={{padding:'24px 0 0 0 '}}
        >
          <Row style={{marginTop:'2px', paddingBottom:'26px', borderBottom: '1px solid #EDF1F7'}}>
            <Col style={{margin:'0px 38px 18px 22px'}}>
              <CloseOutlined onClick={onClose} style={{fontSize:'18px'}} />
            </Col>
            <Col>
            <img height='32px' src='/simular_logo.svg' alt="logo" />
            </Col>
          </Row>
          <Menu content= {props.content} className={props.menuClassName} onClose={onClose}/>
      </Drawer>
    )
}

export default MobileMenu
